// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Fp7Xs1dGgXnBRK {
  position: fixed;
  z-index: 10;
  bottom: var(--ds-space-200, 16px);
  left: 50%;
  transform: translateX(-50%);
  transition: opacity 0.3s ease-in-out, transform 0.3s ease-in-out;
}
.Fp7Xs1dGgXnBRK.miHuD5c32ZSJsP {
  transform: translateX(-50%) translateY(100px);
  opacity: 0;
  pointer-events: none;
}
.Fp7Xs1dGgXnBRK.NEgzb6IVm8aAaP {
  transform: translateX(-50%) translateY(0);
  opacity: 1;
}
.Fp7Xs1dGgXnBRK .r2YOeDHMfCrrDJ {
  position: relative;
  border: 0px;
}
.Fp7Xs1dGgXnBRK .r2YOeDHMfCrrDJ::before {
  /* stylelint-disable design-system/ensure-design-token-usage */
  background: conic-gradient(from 180deg at 50% 50%, #ffa900 -52.2deg, #0065ff 89.76deg, #0469ff 145.8deg, #bf63f3 262.8deg, #ffa900 307.8deg, #0065ff 449.76deg);
  content: '';
  position: absolute;
  top: var(--ds-space-0, 0);
  right: var(--ds-space-0, 0);
  bottom: var(--ds-space-0, 0);
  left: var(--ds-space-0, 0);
  padding: var(--ds-space-025, 2px);
  border-radius: var(--ds-border-radius-300, 12px);
  -webkit-mask: linear-gradient(var(--ds-background-input, #ffffff) 0 0) content-box, linear-gradient(var(--ds-background-input, #ffffff) 0 0);
  mask-composite: exclude;
  pointer-events: none;
}
`, ""]);
// Exports
export var bulkActionIsland = `Fp7Xs1dGgXnBRK`;
export var hidden = `miHuD5c32ZSJsP`;
export var visible = `NEgzb6IVm8aAaP`;
export var buttonGroup = `r2YOeDHMfCrrDJ`;
export default ___CSS_LOADER_EXPORT___;
